import axios, { AxiosRequestConfig } from "axios";

import { IAsset } from "@/v1/components/pages/GameDetail/components/AssetsTab/types/Asset.interface";

import restclient from "../restclient";

export const createFolder = async (gameId: string, path: string) => {
  return restclient.post(`api/v1/games/${gameId}/assets/folders`, { path });
};

export const deleteAsset = async (gameId: string, path: string) => {
  return restclient.delete(`api/v1/games/${gameId}/assets?path=${path}`);
};

export const renameAsset = async (
  gameId: string | number,
  body: { source: string; target: string; force: boolean },
) => {
  return restclient.patch(`/api/v1/games/${gameId}/assets`, body);
};

export const moveAsset = async (
  gameId: string | number,
  body: { source: string; target: string; force: boolean },
) => {
  return restclient.patch(`/api/v1/games/${gameId}/assets`, body);
};

export const uploadAsset = async (
  gameId: string,
  asset: IAsset,
  axiosConfig?: AxiosRequestConfig,
) => {
  const {
    data: { url },
  } = await restclient.get<{ url: string }>(
    `/api/v1/games/${gameId}/assets/request-to-upload?path=${asset.path}&contentType=${asset.file?.type}`,
  );

  return axios({
    method: "PUT",
    url,
    data: asset.file,
    headers: {
      "Content-Type": asset.file?.type as string,
    },
    ...axiosConfig,
  });
};

export const requestTaskUploadUrl = async (key: string, contentType: string) => {
  const {
    data: { url },
  } = await restclient.get<{ url: string }>("/api/v1/assets/request-to-upload", {
    params: { key, type: "TASK", contentType },
  });

  return url;
};

export const uploadFileToPresignedUrl = async (url: string, file: Blob, contentType: string) => {
  return axios.put(url, file, {
    headers: { "Content-Type": contentType },
  });
};

export const getGameAssets = async (gameId: string | number) => {
  return restclient.get(`/api/v1/games/${gameId}/assets`);
};

export const downloadAsset = async (path: string, config?: AxiosRequestConfig) => {
  return restclient.get(`/api/v1${path}`, config);
};

export const downloadAWSDataService = (url: string, axiosConfig: AxiosRequestConfig) => {
  return axios.get<Blob>(url, {
    responseType: "blob",
    ...axiosConfig,
  });
};
